import {createSelector} from "reselect";

const selectModals = state => state.modals;

export const selectIconModal = createSelector(
    [selectModals],
    modals => modals.icons
)
export const selectChangePassModal = createSelector(
    [selectModals],
    modals => modals.changePassModal
)

export const selectToggleSettingModal = createSelector(
    [selectModals],
    modals => modals.settingModal
)

export const selectSignModal = createSelector(
    [selectModals],
    modals => modals.signModal
)

export const selectDrawer = createSelector(
    [selectModals],
    modals => modals.drawer
)

export const selectStatusModal = createSelector(
    [selectModals],
    modals => modals.statusModal
)
export const selectReportsModal = createSelector(
    [selectModals],
    modals => modals.reportsModal
)
export const selectPaymentModal = createSelector(
    [selectModals],
    modals => modals.payment
)
export const selectToggleSuccess = createSelector(
    [selectModals],
    modals => modals.toggleSuccess
)
export const selectInitModal = createSelector(
    [selectModals],
    modals => modals.initModal
)

